import * as React from 'react';

function SvgIconModalSent(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 72 74" fill="none" {...props}>
      <circle cx={38.462} cy={30.538} r={29.538} fill="#FFF2F0" />
      <path
        d="M6.462 48.523L45.847 32.77 37.97 72.154 6.462 48.524z"
        fill="#E8F4FA"
        stroke="#B3BAC5"
        strokeOpacity={0.2}
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M45.847 32.77L16.308 56.4v13.785l7.09-8.468" fill="#E8F4FA" />
      <path
        d="M45.847 32.77L16.308 56.4v13.785l7.09-8.468"
        stroke="#B3BAC5"
        strokeOpacity={0.2}
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 43.6l39.385-15.754-7.877 39.385L4 43.6z"
        stroke="#505F79"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43.385 27.846L13.846 51.477v13.785l7.09-8.468"
        stroke="#505F79"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export const IconModalSent = React.memo(SvgIconModalSent);
